import React from 'react'
import Icon from '../icons/icon'
import InputSingle from '../forms/input-single'
import CloseButton from '../buttons/close-button'

const HeaderSearching = props => {
  return (
    <header className='main-header'>
      <div className='search-action'>
        <Icon name='search' />
      </div>
      <InputSingle />
      <CloseButton />
    </header>
  )
}

export default HeaderSearching



// WEBPACK FOOTER //
// ./src/ui/header/header-searching.js